
import { mapState } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState("menu", ["menuUploadImageList"]),
    getImage() {
      return this.menuUploadImageList.find((img) => img.itemId === this.item.id)
        ?.image;
    }
  }
};
